"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.loadRecaptchaScript = function () {
  if (!document.getElementById('recaptchaScript')) {
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?&hl=es-419';
    script.id = 'recaptchaScript';
    script.nonce = 'cmVjYXB0Y2hhU2NyaXB0Tm9uY2U=';
    script.defer = true;
    script.async = true;
    head.appendChild(script);
  }
};

exports.disableReactDevTools = function () {
  if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object' && process.env.NODE_ENV !== 'development') {
    var devToolsKeys = Object.keys(window.__REACT_DEVTOOLS_GLOBAL_HOOK__);

    for (var index = 0; index <= devToolsKeys.length; index += 1) {
      var newValue = typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__[devToolsKeys[index]] === 'function' ? function () {} : null;
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[devToolsKeys[index]] = newValue;
    }
  }
};

var CONFIG_UTILS = {
  loadRecaptchaScript: exports.loadRecaptchaScript,
  disableReactDevTools: exports.disableReactDevTools
};
exports.default = CONFIG_UTILS;